//
import axios from 'axios'

class WebMethodService {
  static callWebMethod (url, params) {
    //
    const promise = new Promise((resolve, reject) => {
      let isLoading = true
      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then((response) => {
        const payload = JSON.parse(response.data.d)
        //  response is an application error
        if (payload.hasOwnProperty('type') && payload.type == 'FrontendException') {
          //
          reject(payload)
        } else {
          //
          resolve(payload)
        }
      }).catch((err) => {
        //
        reject(err)
      }).finally(() => {
        isLoading = false
      })
    })
    //
    return promise
  }
}

export default WebMethodService
